import { EntryCardDefault } from '@components/EntryCard';

export const EntryCard = EntryCardDefault;
